var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "j-modal",
    {
      attrs: {
        title: _vm.title,
        width: _vm.modelStyle.width,
        visible: _vm.visible,
        bodyStyle: _vm.bodyStyle,
        switchFullscreen: _vm.switchFullscreen
      },
      on: {
        cancel: _vm.handleCancel,
        setInnerFullscreen: _vm.setInnerFullscreen
      }
    },
    [
      _c(
        "template",
        { slot: "footer" },
        [
          _c("a-button", { key: "back", on: { click: _vm.handleCancel } }, [
            _vm._v(_vm._s(_vm.language["common.closeButton"]))
          ])
        ],
        1
      ),
      _c(
        "a-card",
        { staticClass: "daily-article", attrs: { loading: _vm.loading } },
        [
          _c("a-card-meta", {
            attrs: {
              title: _vm.record.titile,
              description:
                _vm.language["announcement.publisher"] +
                "：" +
                (_vm.record.publisher
                  ? _vm.record.publisher
                  : _vm.language["common.not"]) +
                " | " +
                _vm.language["announcement.publishTime"] +
                "：" +
                (_vm.record.publish_time
                  ? _vm.record.publish_time
                  : _vm.language["common.not"])
            }
          }),
          _c("a-divider"),
          _c("span", { staticStyle: { margin: "10px 0px" } }, [
            _vm._v("内容标题: "),
            _c("span", {
              staticClass: "article-content",
              domProps: { innerHTML: _vm._s(_vm.record.contentTitle) }
            })
          ]),
          _c("span", {
            staticClass: "article-content",
            domProps: { innerHTML: _vm._s(_vm.record.contentDetails) }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }